import { SxProps } from '@mui/material'

interface DateRangePickerInputStyles {
  popperWrapper: SxProps
  datePickerWrapper: SxProps
}

export const dateRangePickerInputStyles: DateRangePickerInputStyles = {
  popperWrapper: {
    display: 'flex',
    justifyContent: 'center',
    p: 0,
  },
  datePickerWrapper: {
    borderWidth: 0,
  },
}
